// productPage JS, for page template in datarobot6 theme
// datarobot6/views/templates/product-page.twig

document.addEventListener("DOMContentLoaded", function () {
	var siteHeader = document.querySelector(".siteHeader__navigation"); // fixed nav
	var heroSection = document.querySelector(".productPage__hero"); // hero section
	var productPageContainers = document.querySelectorAll(".productPage__container"); // content sections
	var siteMainContent = document.querySelector(".siteMain"); // main page container
	var productPageContent = document.querySelector(".productPage__content"); // main content container
	var headerHeight = siteHeader ? siteHeader.offsetHeight : 0; // get height of the nav
	var sectionPadding = 4 * 16; // 4rem converted to px (1rem = 16px)
	var isSidebarFixed = false; // track if the sidebar is currently fixed
	var sidebarLinks = []; // keep track of sidebar links
	var isManualScroll = false; // handle scroll-triggered active state
	var isMenuOpen = false; // track the mobile menu state
	let blockObserverUpdates = false; // Flag to temporarily block observer updates
	let idToPreserveOnToggleClose = null; // Stores the active heading ID when menu is closed by toggle
	let menuJustClosedByToggle = false; // Flag to indicate menu was just closed by toggle/outside click

	var productPageHeadings = document.querySelectorAll(".productPage__heading");
	var mainContent = document.querySelector(".productPage__main");

	// Check if there are NO productPage__heading elements
	if (productPageHeadings.length > 0 && mainContent) {
		mainContent.classList.add("-sidebarPresent");
	}

	// Continue with sidebar creation if productPage__heading elements exist
	if (productPageHeadings.length > 0 && productPageContent) {
		var sidebar = document.createElement("div");
		sidebar.classList.add("productPage__sidebar");

		var sidebarInner = document.createElement("div");
		sidebarInner.classList.add("productPage__sidebarMenu");

		// Create toggle button for mobile menu
		var sidebarToggle = document.createElement("div");
		sidebarToggle.classList.add("productPage__sidebarMenuToggle");
		sidebarToggle.classList.remove("-open");
		sidebar.appendChild(sidebarToggle);

		// Iterate over each productPage__container and create sidebar links
		productPageContainers.forEach(function (productPageContainer, index) {
			var heading = productPageContainer.querySelector(".productPage__heading");

			if (!heading) {
				return; // Skip this container if it doesn't have a heading
			}

			var headingId = "heading-" + (index + 1);
			heading.setAttribute("id", headingId);

			var sidebarLink = document.createElement("a");
			sidebarLink.classList.add("productPage__sidebarLink");
			sidebarLink.href = "#" + headingId;

			var sidebarHeading = document.createElement("div");
			sidebarHeading.classList.add("productPage__sidebarHeading");

			// Create icon (if present) and include it
			var icon = productPageContainer.querySelector(".productPage__icon");
			if (icon) {
				var sidebarIcon = document.createElement("div");
				sidebarIcon.classList.add("productPage__icon", "-sidebar");
				sidebarIcon.innerHTML = icon.innerHTML; // Copy the icon content
				sidebarHeading.appendChild(sidebarIcon);
			}

			var title = productPageContainer.querySelector(".productPage__headingTitle");
			if (title) {
				var sidebarTitle = document.createElement("div");
				sidebarTitle.classList.add("productPage__sidebarTitle");
				sidebarTitle.innerText = title.innerText;
				sidebarHeading.appendChild(sidebarTitle);
			}

			sidebarLink.appendChild(sidebarHeading);

			// Add description if available
			// Optionally get the description (if it exists) and create a new sidebar description
			var description = productPageContainer.querySelector(".productPage__headingDescription");
			if (description && description.innerText !== "") {
				var sidebarDescription = document.createElement("div");
				sidebarDescription.classList.add("productPage__sidebarDescription");

				// Create a new span with class productPage__sidebarDescriptionText and copy the description text into it
				var descriptionText = document.createElement("span");
				descriptionText.classList.add("productPage__sidebarDescriptionText");
				descriptionText.innerText = description.innerText; // Copy the text content

				// Append the span inside the sidebar description
				sidebarDescription.appendChild(descriptionText);
				sidebarLink.appendChild(sidebarDescription);
			}

			// Add sidebar link to the array for tracking later
			sidebarLinks.push(sidebarLink);

			// Smooth scrolling when a sidebar link is clicked
			sidebarLink.addEventListener("click", function (event) {
				event.preventDefault();
				isManualScroll = true;

				const targetId = sidebarLink.getAttribute("href").substring(1);
				const targetElement = document.getElementById(targetId);

				menuJustClosedByToggle = false;
				idToPreserveOnToggleClose = null;

				if (!targetElement) {
					return;
				}

				const isSidebarExpanded = sidebarInner.classList.contains("-expanded");
				const collapsedSidebarHeight = sidebar && typeof sidebar.offsetHeight !== "undefined" ? sidebar.offsetHeight : 0;
				const expandedSidebarHeight = isSidebarExpanded && sidebarInner && typeof sidebarInner.offsetHeight !== "undefined" ? sidebarInner.offsetHeight : 0;

				const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY;
				const navOffset = siteHeader ? siteHeader.offsetHeight : 0;
				let scrollOffset;

				if (window.innerWidth >= 1024) {
					scrollOffset = navOffset + 4 * 16;
				} else {
					scrollOffset = navOffset + (isSidebarExpanded ? expandedSidebarHeight : collapsedSidebarHeight);
				}

				window.scrollTo({
					top: targetPosition - scrollOffset,
					behavior: "smooth",
				});

				sidebarLinks.forEach(function (link) {
					link.classList.remove("-active");
				});
				sidebarLink.classList.add("-active");
				currentActiveHeadingId = targetId;

				closeMobileMenu(false); // Close menu, not by toggle

				setTimeout(() => {
					isManualScroll = false;
				}, 500);
			});
			sidebarInner.appendChild(sidebarLink);
		});

		sidebar.appendChild(sidebarInner);
		var productPageMain = productPageContent.querySelector(".productPage__main");
		if (productPageMain) {
			productPageContent.insertBefore(sidebar, productPageMain);
		}

		// Declare variables in the correct scope.
		let observer = null;
		let currentObserverStickyThreshold = 0;
		let currentActiveHeadingId = null;
		// Convert NodeList to Array for easier indexOf operations, and to ensure it's static.
		const productPageHeadingsArray = Array.from(productPageHeadings);

		// Helper function to get the current sticky threshold based on window width.
		// This threshold determines the offset for the sticky sidebar and IntersectionObserver.
		function getStickyThreshold() {
			const windowWidth = window.innerWidth;
			if (windowWidth >= 1024) {
				return 8 * 16; // 128px for desktop.
			} else if (windowWidth >= 768) {
				return 88; // 88px for tablet.
			} else {
				return 52; // 52px for mobile.
			}
		}

		// Function to check and apply sticky class
		function checkStickySidebar() {
			if (!sidebar || typeof sidebar.getBoundingClientRect !== "function") {
				return;
			}

			const sidebarRect = sidebar.getBoundingClientRect();
			const stickyThreshold = getStickyThreshold();

			// A small buffer for floating point comparisons, can be adjusted if needed
			const buffer = 1;

			if (sidebarRect.top <= stickyThreshold + buffer) {
				sidebar.classList.add("-isSticky");
			} else {
				sidebar.classList.remove("-isSticky");
			}
		}

		// Initial check in case the page loads in a scrolled state or sidebar is immediately sticky
		checkStickySidebar();

		// Add event listeners for scroll and resize to dynamically update the sticky state
		window.addEventListener("scroll", checkStickySidebar);

		function setupIntersectionObserver() {
			if (observer) {
				observer.disconnect(); // Disconnect the old observer if it exists.
			}

			const stickyThreshold = getStickyThreshold();
			currentObserverStickyThreshold = stickyThreshold; // Store the threshold used for this observer.

			const viewportHeight = window.innerHeight;
			const bottomMarginPx = -(viewportHeight - stickyThreshold - 1);

			const observerOptions = {
				root: null,
				threshold: 0,
				rootMargin: `-${stickyThreshold}px 0px ${bottomMarginPx}px 0px`,
			};

			observer = new IntersectionObserver(function (entries) {
				// IntersectionObserver now simply triggers a full state update.
				if (isManualScroll) return;
				updateActiveState();
			}, observerOptions);

			productPageHeadings.forEach(function (heading) {
				observer.observe(heading);
			});

			// Initial state update after observer is set up.
			updateActiveState();
		}

		// Master function to determine and set the active sidebar link.
		function updateActiveState() {
			if (blockObserverUpdates || isManualScroll) {
				return;
			}

			let finalNewActiveHeadingId = null;

			if (menuJustClosedByToggle && idToPreserveOnToggleClose !== null) {
				finalNewActiveHeadingId = idToPreserveOnToggleClose;
				menuJustClosedByToggle = false;
				idToPreserveOnToggleClose = null;
			} else {
				if (menuJustClosedByToggle) {
					menuJustClosedByToggle = false;
				}

				const currentStickyLinePosition = getStickyThreshold();
				const buffer = 1;
				let determinedIdByScroll = null;

				for (let i = productPageHeadingsArray.length - 1; i >= 0; i--) {
					const heading = productPageHeadingsArray[i];
					const rect = heading.getBoundingClientRect();
					if (rect.top <= currentStickyLinePosition + buffer) {
						determinedIdByScroll = heading.getAttribute("id");
						break;
					}
				}

				if (determinedIdByScroll !== null) {
					finalNewActiveHeadingId = determinedIdByScroll;
				} else {
					if (sidebarLinks.length > 0) {
						finalNewActiveHeadingId = sidebarLinks[0].getAttribute("href").split("#")[1];
					} else {
						finalNewActiveHeadingId = null;
					}
				}
			}

			if (currentActiveHeadingId !== finalNewActiveHeadingId) {
				currentActiveHeadingId = finalNewActiveHeadingId;
				sidebarLinks.forEach(function (link) {
					const linkHrefId = link.getAttribute("href").split("#")[1];
					link.classList.toggle("-active", linkHrefId === currentActiveHeadingId && currentActiveHeadingId !== null);
				});
			}
		}

		setupIntersectionObserver(); // Initial setup of the IntersectionObserver.

		function reattachObserver() {
			if (observer && productPageHeadings.length > 0) {
				productPageHeadings.forEach(function (heading) {
					observer.observe(heading);
				});
			}
		}

		// Function to open the mobile menu
		function openMobileMenu() {
			if (isMenuOpen) {
				return;
			}
			isMenuOpen = true;

			idToPreserveOnToggleClose = null;
			menuJustClosedByToggle = false;

			// Block updates during menu opening to prevent unwanted active state reset
			blockObserverUpdates = true;

			sidebarInner.classList.add("-expanded");
			sidebarToggle.classList.add("-open");
			sidebarInner.offsetHeight; // Force reflow

			updateActiveState();

			// Unblock updates after a short delay to allow menu animation to complete
			setTimeout(() => {
				blockObserverUpdates = false;
			}, 350);
		}

		// Function to close the mobile menu
		function closeMobileMenu(closedByToggleButtonOrOutside = false) {
			if (!isMenuOpen) {
				return;
			}

			isMenuOpen = false; // Set this early

			if (closedByToggleButtonOrOutside) {
				idToPreserveOnToggleClose = currentActiveHeadingId;
				menuJustClosedByToggle = true;

				blockObserverUpdates = true;

				sidebarInner.classList.remove("-expanded");
				sidebarToggle.classList.remove("-open");

				setTimeout(() => {
					updateActiveState();

					setTimeout(() => {
						blockObserverUpdates = false;
					}, 50);
				}, 350);
			} else {
				idToPreserveOnToggleClose = null;
				menuJustClosedByToggle = false;

				blockObserverUpdates = true;

				sidebarInner.classList.remove("-expanded");
				sidebarToggle.classList.remove("-open");

				setTimeout(() => {
					blockObserverUpdates = false;
					updateActiveState(); // Ensure state is updated after closing
				}, 350);
			}
		}

		// Combined toggle function for the toggle button
		function toggleMobileMenu() {
			const menuIsCurrentlyExpanded = sidebarInner.classList.contains("-expanded");

			if (menuIsCurrentlyExpanded) {
				closeMobileMenu(true);
			} else {
				openMobileMenu();
			}
		}

		// Toggle the sidebar menu on click
		sidebarToggle.addEventListener("click", function (event) {
			event.stopPropagation();
			toggleMobileMenu();
		});

		// Close the sidebar menu when clicking outside
		document.addEventListener("click", function (event) {
			if (isMenuOpen && sidebar && sidebarInner && sidebarToggle && !sidebar.contains(event.target) && !sidebarToggle.contains(event.target)) {
				if (!sidebarInner.contains(event.target)) {
					closeMobileMenu(true);
				}
			} else if (isMenuOpen) {
			}
		});

		// Consolidated resize handler for various screen size adjustments.
		window.addEventListener("resize", function () {
			// Update sidebar stickiness based on the current viewport width.
			checkStickySidebar();

			// Update IntersectionObserver if the sticky threshold has changed.
			// This ensures the active section highlighting remains accurate.
			const newStickyThreshold = getStickyThreshold();
			if (newStickyThreshold !== currentObserverStickyThreshold) {
				setupIntersectionObserver();
			}

			// Collapse the mobile menu if the screen is resized to desktop width.
			if (window.innerWidth >= 1024 && isMenuOpen) {
				// Check isMenuOpen
				closeMobileMenu(false); // Treat resize close like a programmatic one, not toggle
			}
		});

		// Add scroll event listener to update state after menu is closed
		window.addEventListener("scroll", function () {
			if (!isMenuOpen && !blockObserverUpdates && !isManualScroll) {
				updateActiveState();
			}
		});
	}
});
